module.exports = __webpack_public_path__ + "static/lau-cover-masked-86bf402aa471d81a473cbce6d9ea42c4.png";